import * as React from 'react';

function SvgProgressCancelled(props) {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.08 17.98A7.75 7.75 0 0018 7.1L7.07 18zm-1.06-1.06L16.94 6.03a7.75 7.75 0 00-10.93 10.9zM12 21.25a9.25 9.25 0 110-18.5 9.25 9.25 0 010 18.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgProgressCancelled;
